export default __webpack_public_path__ + "9d95d75f20c51c8ee5c9957e8fc417ea.woff";